<template>
  <el-dialog title="发布许愿墙任务" :visible.sync="visible" width="600px" :before-close="handleClose"
    :close-on-click-modal="false">
    <!-- 第一步：填写任务信息 -->
    <el-form v-show="step === 'form'" ref="taskForm" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="任务标题" prop="title">
        <el-input v-model="form.title" placeholder="请输入任务标题" maxlength="64" show-word-limit />
      </el-form-item>
      <el-form-item label="任务描述" prop="content">
        <el-input v-model="form.content" type="textarea" :rows="3" placeholder="请描述任务详情" maxlength="1024"
          show-word-limit />
      </el-form-item>
      <el-form-item label="期望完成时间" prop="taskTime">
        <el-date-picker v-model="form.taskTime" type="datetime" placeholder="选择期望完成时间"
          value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入任务地址" maxlength="200" />
      </el-form-item>
      <el-form-item label="联系人" prop="contactName">
        <el-input v-model="form.contactName" placeholder="请输入联系人" maxlength="64" />
      </el-form-item>
      <el-form-item label="联系方式" prop="contactTel">
        <el-input v-model="form.contactTel" placeholder="请输入联系方式" maxlength="20" />
      </el-form-item>
      <el-form-item label="任务报酬(元)" prop="reward">
        <el-input v-model="form.reward" placeholder="请输入报酬金额，发布后进入平台托管" type="number" min="0.01" step="0.01">
          <template slot="prepend">￥</template>
        </el-input>
        <div class="tip-text">报酬将在发布时支付并托管，任务确认完成后发放给接单人；未接单可取消并退回。</div>
      </el-form-item>
    </el-form>

    <!-- 第二步：扫码支付 -->
    <div v-show="step === 'qrcode'" class="qrcode-wrap">
      <p class="qrcode-title">请使用微信扫一扫支付报酬 ￥{{ form.reward }}</p>
      <div id="taskWallQrcode" class="qrcode-box"></div>
      <p class="qrcode-tip">支付完成后任务将自动进入"待接单"状态</p>
    </div>

    <div slot="footer" class="dialog-footer">
      <template v-if="step === 'form'">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleSubmit">发布并支付</el-button>
      </template>
      <template v-else>
        <el-button @click="handleClose">关闭</el-button>
        <el-button type="primary" @click="handlePaid">我已完成支付</el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import QRCode from 'qrcodejs2'
import { publishTaskWallPay } from '@/api/community/taskWallManageApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getUserName, getUserTel } from '@/api/user/userApi'

export default {
  name: 'AddTaskWall',
  data() {
    return {
      visible: false,
      loading: false,
      step: 'form',
      qrcode: null,
      form: {
        title: '',
        content: '',
        taskTime: '',
        address: '',
        contactName: '',
        contactTel: '',
        reward: ''
      },
      rules: {
        title: [{ required: true, message: '请输入任务标题', trigger: 'blur' }],
        taskTime: [{ required: true, message: '请选择期望完成时间', trigger: 'change' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        contactName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactTel: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        reward: [
          { required: true, message: '请输入任务报酬', trigger: 'blur' },
          { validator: this.validateReward, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.resetForm()
      // 默认带出当前物业员工联系方式，可修改
      this.form.contactName = getUserName() || ''
      this.form.contactTel = getUserTel() || ''
      this.step = 'form'
      this.visible = true
    },
    resetForm() {
      this.form = {
        title: '',
        content: '',
        taskTime: '',
        address: '',
        contactName: '',
        contactTel: '',
        reward: ''
      }
      this.clearQrcode()
      if (this.$refs.taskForm) {
        this.$refs.taskForm.clearValidate()
      }
    },
    validateReward(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入任务报酬'))
        return
      }
      const num = Number(value)
      if (isNaN(num) || num <= 0) {
        callback(new Error('任务报酬必须大于0'))
        return
      }
      callback()
    },
    handleSubmit() {
      this.$refs.taskForm.validate(async valid => {
        if (!valid) {
          return
        }
        try {
          this.loading = true
          const res = await publishTaskWallPay({
            business: 'taskWall',
            tradeType: 'NATIVE',
            payAdapt: 'wechatNativeQrcodePaymentFactory',
            communityId: getCommunityId(),
            title: this.form.title,
            content: this.form.content,
            taskTime: this.form.taskTime,
            address: this.form.address,
            contactName: this.form.contactName,
            contactTel: this.form.contactTel,
            reward: this.form.reward
          })
          const code = String(res.code)
          // 演示环境/0元：直接支付成功
          if (code === '100') {
            this.$message.success(res.msg || '发布成功')
            this.$emit('success')
            this.handleClose()
            return
          }
          // 需要唤起扫码支付
          if (code === '0' && res.codeUrl) {
            this.step = 'qrcode'
            this.$nextTick(() => {
              this.generateQrcode(res.codeUrl)
            })
            return
          }
          this.$message.error(res.msg || '发布失败')
        } catch (error) {
          console.error('发布任务失败:', error)
          this.$message.error('发布任务失败')
        } finally {
          this.loading = false
        }
      })
    },
    generateQrcode(codeUrl) {
      this.clearQrcode()
      const el = document.getElementById('taskWallQrcode')
      if (!el) {
        return
      }
      this.qrcode = new QRCode(el, {
        text: codeUrl,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.L
      })
    },
    clearQrcode() {
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode = null
      }
      const el = document.getElementById('taskWallQrcode')
      if (el) {
        el.innerHTML = ''
      }
    },
    handlePaid() {
      this.$message.success('如已支付，任务稍后将出现在列表中')
      this.$emit('success')
      this.handleClose()
    },
    handleClose() {
      this.clearQrcode()
      this.visible = false
      this.step = 'form'
    }
  },
  beforeDestroy() {
    this.clearQrcode()
  }
}
</script>

<style lang="scss" scoped>
.tip-text {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.qrcode-wrap {
  text-align: center;
  padding: 10px 0;

  .qrcode-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .qrcode-box {
    width: 220px;
    height: 220px;
    margin: 0 auto;
    border: 1px solid #eee;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qrcode-tip {
    color: #909399;
    margin-top: 15px;
  }
}

.dialog-footer {
  text-align: right;
}
</style>
